import React, { useEffect, useRef, useState } from 'react';
import { Paper } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router';
import LeadPrincipalInfo from './LeadPrincipalinfo';
import SiteInfoTable from './SiteInfoTable';
import { useDispatch, useSelector } from 'react-redux';
import { setGlobalLoading } from 'store/global/reducer';
import CustomButton from 'components/CustomInput/Button';
import TextHeader from 'components/CustomText/TextHeader';
import LoadingIndicator from 'components/LoadingIndicator';
import CIDelegationTable from './CIDelegationTable';
import styled from 'styled-components';
import api from 'api/call';
import { produce, isHighlight as isHL, compareEmail } from 'utility/general';
import useDialog from 'components/ConfirmDialog/useDialog';
import { updateDialog } from 'store/dialog/reducer';
import {
    ABORT_TEAM_MEMBER_FORM,
    DRAFT_CREATE,
    INVALID_USER_IN_TEAM_MEMBER,
    NO_SITE_PI_EXIST,
    TEAM_MEMBER_FORM_COMPLETENESS,
} from 'utility/frontendMessage';
import { isEmpty } from 'lodash';
import {
    RESET_APPLICATION_FORM_INITIAL_POST_DATA,
    UPDATE_APPLICATION_DETAIL_POST_DATA,
    UPDATE_FORM_VALIDITY,
    APPLICATION_DETAIL_FETCH,
} from 'store/key';
import SiteDelegationTable from './SiteDelegationTable';
import useQuery from 'hooks/useQuery';
import { KEY_PATHNAME } from 'utility/lookup';
import { getItem } from 'storage';
import { setGlobal } from 'store/global/reducer';
import usePrevious from 'hooks/usePrevious';
const SActionLayout = styled.div`
    padding: 10px;
    background: #ecebf3;
`;

const SGapRow = styled.div`
    margin-top: 20px;
`;

const SLoadingLayout = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

// applicationDetail = {} means team member form is creating without previous data
const TeamMemberForm = ({
    tabType,
    applicationDetail = {},
    onFormUpdate = (key, value) => null,
    siteInfoId,
    formId,
    disableOnPermission = false,
    isAmendmentCreate = false,
    isAmendmentEdit = false,
    applicationCreateDtm,
}) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const showDialog = useDialog();
    const [postData, setPostData] = useState({});
    const validationData = useRef({});
    const userDetail = useSelector((state) => state.user.detail);
    const [forceInfoErrorDisplay, setForceInfoErrorDisplay] = useState(false);
    const isFormCreate = isEmpty(applicationDetail);
    const previousFormCreate = usePrevious(isFormCreate);
    const application = useSelector((state) => state.application);

    const isClone = location.pathname.includes('/clone');
    const isCloneSite = useQuery('cloneSite') === 'true';
    const cloneId = useQuery('cloneId');
    const [customDataKey, setCustomDataKey] = useState(1);

    const clonedApplicationDetail = useSelector(
        (state) => state.applicationDetail[cloneId ?? 'undefined'],
    );
    const clonedWorkflow = isCloneSite ? clonedApplicationDetail?.applicationForm?.workflow : undefined;

    const validationKey = 'teamMember';

    const isStudyValid = useSelector(
        (state) => state.applicationDetailValid.isApplicationFormDetailValid?.[validationKey],
    );

    const [piTableData, setPITableData] = useState([]);
    const [ciDelegateData, setCIDelegateData] = useState([]);

    // when user switch from application detail page to /applications/new page
    useEffect(() => {
        // clear postData if the page is from detail to create new application page
        if (isFormCreate !== previousFormCreate) {
            dispatch({
                type: RESET_APPLICATION_FORM_INITIAL_POST_DATA,
            });

            setTimeout(() => {
                setCustomDataKey(customDataKey + 1);
                setPostData({});
            }, 100);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFormCreate, previousFormCreate]);

    useEffect(() => {
        updateFormValidation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabType]);

    useEffect(() => {
        if (isCloneSite) {
            setGlobalLoading(true);

            dispatch({
                type: APPLICATION_DETAIL_FETCH,
                payload: { id: cloneId },
            });

            setGlobalLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCloneSite]);

    useEffect(() => {
        if (isCloneSite && clonedApplicationDetail) {
            setPostData((prev) =>
                produce(prev, (draft) => {
                    draft.pi = clonedApplicationDetail.pi;
                    draft.workflow = clonedWorkflow;
                    draft.isCloneSite = true;
                })
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clonedApplicationDetail]);

    const getData = (key) => {
        return postData?.[key] ?? applicationDetail?.applicationForm?.workflow;
    };

    const onPostDataUpdate = (type, data) => {
        setPostData(
            produce((draft) => {
                draft[type] = data;
            }),
        );
    };

    const onEditFormDataUpdate = (name, value) => {
        // handle case of teamMember form update
        if (!isFormCreate) {
            dispatch({
                type: UPDATE_APPLICATION_DETAIL_POST_DATA,
                payload: {
                    type: 'applicationForm',
                    key: name,
                    data: value,
                    applicationFormId: applicationDetail.applicationForm.id,
                },
            });
        }
    };

    const onCreateFormDataUpdated = (data) => {
        // case of creating application form
        const newData = produce(postData, (draft) => {
            Object.entries(data).forEach(([key, value]) => {
                draft[key] = value;
            });
        });

        setPostData(newData);

        // update all data one by one
        Object.entries(newData).forEach(([key, value]) => {
            onFormUpdate(key, value);
        });
    };

    const updateFormValidation = () => {
        // update form validation in redux only if form is editing
        if (!isFormCreate) {
            const validations = Object.values(validationData.current);

            const currentStatus = validations.every((item) => item);

            if (currentStatus !== isStudyValid) {
                dispatch({
                    type: UPDATE_FORM_VALIDITY,
                    payload: {
                        type: 'study',
                        applicationFormId: formId,
                        // siteInfoId: siteInfoId,
                        formKey: validationKey,
                        isValid: currentStatus,
                    },
                });
            }
        }

        // default pass validation in site-info tab
        if (tabType === 'hospital' && !isFormCreate) {
            dispatch({
                type: UPDATE_FORM_VALIDITY,
                payload: {
                    type: 'site',
                    applicationFormId: formId,
                    siteInfoId: siteInfoId,
                    formKey: validationKey,
                    isValid: true,
                },
            });
        }
    };

    const onValidationUpdate = (validation) => {
        validationData.current = validation;
        updateFormValidation();
    };

    const checkIfUserExistsInForm = () => {
        const data = postData;
        let isExist = false;

        if (compareEmail(data.email, userDetail.email)) {
            isExist = true;
        }

        data?.ciDelegation?.forEach((item) => {
            if (compareEmail(item.email, userDetail.email)) {
                isExist = true;
            }
        });

        return isExist;
    };

    const formValidation = async () => {
        const hasError = Object.values(validationData.current).some((item) => !item);

        if (hasError) {
            return false;
        }

        const isSitePiExist = postData.pi?.length > 0;

        if (hasError) {
            await showDialog({ description: TEAM_MEMBER_FORM_COMPLETENESS, disableCancelButton: true });
            setForceInfoErrorDisplay(true);
            return false;
        }

        if (!isSitePiExist) {
            await showDialog({ description: NO_SITE_PI_EXIST, disableCancelButton: true });
            setForceInfoErrorDisplay(true);
            return false;
        }

        // if application clone, skip checking the user must exist in the form
        if (!cloneId) {
            // check if current user is one of member in either coordinating investigator or site pi(s)
            const isUserExistInApplication = checkIfUserExistsInForm();

            if (!isUserExistInApplication) {
                await showDialog({
                    description: INVALID_USER_IN_TEAM_MEMBER,
                    disableCancelButton: true,
                });

                return false;
            }
        }

        return true;
    };

    const cloneApplication = async () => {
        const isValid = await formValidation();

        if (!isValid) {
            setForceInfoErrorDisplay(true);
            return;
        }

        try {
            const dataWithoutId = produce(postData, (draft) => {
                draft.pi.forEach((item) => {
                    delete item.id;
                });

                // ci delegation is optional
                draft?.ciDelegation?.forEach((item) => {
                    delete item.id;
                });
            });

            setGlobalLoading(true);

            await api.application.cloneApplicationDraft(cloneId, dataWithoutId);

            setGlobalLoading(false);

            history.push(`/applications/all`);

            await showDialog({
                description: DRAFT_CREATE,
                disableCancelButton: true,
            });
        } catch (error) {
            console.log('162026 index.jsx error', error);
        }

        setGlobalLoading(false);
    };

    const handleNav = () => {
        history.push('/help');
        dispatch(
            updateDialog({
                isShow: false,
            }),
        );
    }

    const createDraftApplication = async () => {
        const isValid = await formValidation();

        if (!isValid) {
            setForceInfoErrorDisplay(true);
            return;
        }

        try {
            const dataWithoutId = produce(postData, (draft) => {
                draft.pi.forEach((item) => {
                    delete item.id;
                });

                // ci delegation is optional
                draft?.ciDelegation?.forEach((item) => {
                    delete item.id;
                });
            });

            setGlobalLoading(true);

            const res = await api.application.createApplicationDraft(dataWithoutId);

            setGlobalLoading(false);

            history.push(`/applications/initial-application-form?id=${res.data.result}`);
            let desc = postData.workflow === 'I' ?
                <>{DRAFT_CREATE}<br /><br /> Draft templates of study documents are available for reference in the <a href='#' onClick={handleNav}>Useful Information/User Manual</a>.</>
                :
                DRAFT_CREATE
                ;
            await showDialog({
                description: desc,
                disableCancelButton: true,
                confirmButtonText: 'Close',
            });
        } catch (error) {
            console.log('162026 index.jsx error', error);
        }

        setGlobalLoading(false);
    };

    const handleCancelClick = async () => {
        const isConfirm = await showDialog({
            description: ABORT_TEAM_MEMBER_FORM,
        });

        if (!isConfirm) {
            return;
        }

        dispatch(
            setGlobal({
                isDetailBack: true,
            }),
        );

        history.push(getItem(KEY_PATHNAME) ?? `/applications/${application.folder || 'all'}`);
    };

    const onSitePiTableChange = (data) => {
        onPostDataUpdate('pi', data);
        onFormUpdate('pi', data);
    };

    const isHighlight = (keys, istable = false) => {
        if (isFormCreate) return false;
        return isHL(applicationDetail, siteInfoId, formId, tabType, keys, istable);
    };

    return (
        <div>
            {isFormCreate && (
                <SActionLayout>
                    <CustomButton onClick={isClone ? cloneApplication : createDraftApplication}>
                        {isClone ? 'Clone' : 'Create'}
                    </CustomButton>
                    <CustomButton type={'cancel'} style={{ marginLeft: 20 }} onClick={handleCancelClick}>
                        Cancel
                    </CustomButton>
                </SActionLayout>
            )}
            {isCloneSite && !clonedApplicationDetail ? (
                <SLoadingLayout>
                    <LoadingIndicator />
                </SLoadingLayout>
            ) : (
                <Paper style={{ margin: 10, padding: 10, height: '100%' }}>
                    <TextHeader underline italic>
                        Team Member Form
                    </TextHeader>
                    {tabType !== 'hospital' && (
                        <>
                            <LeadPrincipalInfo
                                key={customDataKey}
                                disableOnPermission={disableOnPermission}
                                isFormCreate={isFormCreate}
                                data={postData}
                                piTableData={piTableData}
                                defaultData={applicationDetail.applicationForm}
                                onDataUpdate={onCreateFormDataUpdated}
                                onItemUpdate={onEditFormDataUpdate}
                                onValidationUpdate={onValidationUpdate}
                                forceErrorDisplay={forceInfoErrorDisplay}
                                isHighlight={isHighlight}
                                isAmendmentCreate={isAmendmentCreate}
                                isAmendmentEdit={isAmendmentEdit}
                                applicationCreateDtm={applicationCreateDtm}
                                clonedWorkflow={clonedWorkflow}
                            />
                            <SGapRow>
                                <CIDelegationTable
                                    key={isFormCreate}
                                    disableOnPermission={disableOnPermission}
                                    piTableData={piTableData}
                                    defaultData={applicationDetail.ciDelegation}
                                    isFormCreate={isFormCreate}
                                    applicationDetail={applicationDetail}
                                    onTableDataUpdate={(data) => setCIDelegateData(data)}
                                    onTableChange={(data) => {
                                        onFormUpdate('ciDelegation', data);
                                        onPostDataUpdate('ciDelegation', data);
                                    }}
                                    isHighlight={isHighlight}
                                    isAmendmentCreate={isAmendmentCreate}
                                    isAmendmentEdit={isAmendmentEdit}
                                    applicationCreateDtm={applicationCreateDtm}
                                />
                            </SGapRow>
                        </>
                    )}
                    {(tabType === 'info' || isFormCreate) && (
                        <SGapRow>
                            <SiteInfoTable
                                key={isFormCreate}
                                disableOnPermission={disableOnPermission}
                                ciDelegateData={ciDelegateData}
                                defaultData={applicationDetail.pi}
                                workflow={getData('workflow') ?? clonedWorkflow}
                                isFormCreate={isFormCreate}
                                applicationDetail={isCloneSite ? clonedApplicationDetail : applicationDetail}
                                onTableChange={onSitePiTableChange}
                                onTableDataUpdate={(data) => setPITableData(data)}
                                isHighlight={isHighlight}
                                isAmendmentCreate={isAmendmentCreate}
                                isAmendmentEdit={isAmendmentEdit}
                                applicationCreateDtm={applicationCreateDtm}
                            />
                        </SGapRow>
                    )}
                    {!isFormCreate && tabType === 'hospital' && (
                        <SiteDelegationTable
                            key={`${formId}-${siteInfoId}`}
                            disableOnPermission={disableOnPermission}
                            applicationDetail={applicationDetail}
                            siteInfoId={siteInfoId}
                            isHighlight={isHighlight}
                            isAmendmentCreate={isAmendmentCreate}
                            isAmendmentEdit={isAmendmentEdit}
                            applicationCreateDtm={applicationCreateDtm}
                        />
                    )}
                </Paper>
            )}
        </div>
    );
};

export default TeamMemberForm;
